export default __webpack_public_path__ + "static/1897-d7fd8d5584e6e3a46ec1a74a30057436.gif";